export default "__VITE_ASSET__iwyVMFbm__"